import { Faq, Title, HR } from './faq-styles'
import { Fragment } from 'react'
import QuestionAndAns from './qAndas'
import { FandQItemProps } from './faq-types'

const FaqItem = ({ title, qAndAs }: FandQItemProps) => {
  return (
    <Faq>
      <Title>{title}</Title>
      {qAndAs.map((qa, index) => (
        <Fragment key={index}>
          <QuestionAndAns answer={qa.answer} question={qa.question} key={index} />
          {index + 1 < qAndAs.length && <HR />}
        </Fragment>
      ))}
    </Faq>
  )
}
export default FaqItem
